// extracted by mini-css-extract-plugin
module.exports = {"subscriptionProduct":"SummarySubscriptionItem_subscriptionProduct__Krw3s","singleItemList":"SummarySubscriptionItem_singleItemList__jCEwO"};